import { render, staticRenderFns } from "./AsignarRoles.vue?vue&type=template&id=af00d194&scoped=true"
import script from "./AsignarRoles.vue?vue&type=script&lang=js"
export * from "./AsignarRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af00d194",
  null
  
)

export default component.exports